import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=1ba08365"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCheckoutSubscriptionKeepSubscription: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Subscription/KeepSubscription.vue').default,TlmCheckoutSubscriptionAbonnementDetails: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Subscription/AbonnementDetails.vue').default,TlmCheckoutMenuPanel: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/TlmCheckoutMenuPanel.vue').default})
